import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'LuxKit/Divider'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import useLoyaltyConfig from 'loyalty/hooks/useLoyaltyConfig'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'

function getUSPs(enabledBenefits: App.LoyaltyRegionEnabledBenefits, intl: ReturnType<typeof useIntl>) {
  const vipBenefitsDescriptionWithLounge = intl.formatMessage({
    id: 'RkAQGdNlSGn060oweAEM',
    defaultMessage: 'The more you travel, the more you unlock, from chauffeur airport transfers, room upgrades to lounge passes and more.',
    description: 'Loyalty USP description for VIP benefits when lounge pass benefit is enabled',
  })
  const vipBenefitsDescriptionWithoutLounge = intl.formatMessage({
    id: 'FFPBBh4UkEsoZIFAqRSI',
    defaultMessage: 'The more you travel, the more you unlock, from chauffeur airport transfers, room upgrades and more.',
    description: 'Loyalty USP description for VIP benefits when lounge pass benefit is not enabled',
  })

  return [
    {
      title: intl.formatMessage({
        id: 'OB_3_yp42FbLEu6AshgK',
        defaultMessage: 'Instant VIP benefits',
        description: 'Loyalty USP section title for VIP benefits in the loyalty section',
      }),
      description: (
        <>
          {/* @TODO - make dynamic for all benefits */}
          {enabledBenefits.lounge_pass && <>{vipBenefitsDescriptionWithLounge}</>}
          {!enabledBenefits.lounge_pass && <>{vipBenefitsDescriptionWithoutLounge}</>}
        </>
      ),
    },
    {
      title: intl.formatMessage({
        id: 'nz2UDUua_XEHMyem-jZ9',
        defaultMessage: 'Earn & save',
        description: 'Loyalty USP section title for earning and saving points',
      }),
      description: intl.formatMessage({
        id: '3Exu1_NPI6tvggeuh5Eu',
        defaultMessage: 'Get rewarded every time you book. Earn points and use them to pay less on future escapes.',
        description: 'Loyalty USP description for earning and saving points on bookings',
      }),
    },
    {
      title: intl.formatMessage({
        id: '6hqzcDSknYdcUCOPf004',
        defaultMessage: 'It’s free!',
        description: 'Loyalty USP section title emphasizing free membership',
      }),
      description: intl.formatMessage({
        id: 'QZkaRYnEBmAoQ4wAISRn',
        defaultMessage: 'You can enjoy exclusive perks, points, and VIP benefits without paying to join.',
        description: 'Loyalty USP description explaining membership is free to join',
      }),
    },
  ]
}

const USPSection = styled.div`
  display: grid;
  gap: ${rem(16)};
  padding: ${rem(24)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr min-content 1fr min-content 1fr;
    gap: ${rem(40)};
    padding: ${rem(48)} 0;
  }
`

function LoyaltyLandingPageUSPSection() {
  const intl = useIntl()
  const [config, configFetching, configError] = useLoyaltyConfig()

  if (configFetching) return <LoadingIndicator />
  if (!config || configError) return null

  const usps = getUSPs(config.regionEnabledBenefits, intl)
  return <Pane paletteType="inverse">
    <LayoutContainer>
      <USPSection>
        {usps.map((usp, index) => <React.Fragment key={usp.title}>
          {index !== 0 && <Divider kind="primary" direction="horizontal" tabletDirection="vertical" />}
          <VerticalSpacer gap={4}>
            <Heading variant="heading5" align="center">{usp.title}</Heading>
            <BodyText variant="medium" align="center">{usp.description}</BodyText>
          </VerticalSpacer>
        </React.Fragment>)}
      </USPSection>
    </LayoutContainer>
  </Pane>
}

export default LoyaltyLandingPageUSPSection
